import { Component, OnInit, Inject } from '@angular/core';
import { EFormControl } from '../../../../shared-components/e-forms/e-form-control.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EFormService } from '../../../../shared-components/e-forms/e-form.service';
import { EFormDesignerService } from '../e-form-designer.service';

@Component({
  selector: 'app-value-from-another-field-dialog',
  templateUrl: './value-from-another-field-dialog.component.html',
  styleUrls: ['./value-from-another-field-dialog.component.css']
})
export class ValueFromAnotherFieldDialogComponent implements OnInit {

  objects: EFormControl[];
  selectedObject: EFormControl;
  constructor(
    private eFormDesignerService: EFormDesignerService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ValueFromAnotherFieldDialogComponent>,
    private eFormService: EFormService
  ) { }

  ngOnInit() {
    this.getPromptForDataObjects();
  }

  getPromptForDataObjects() {
    this.objects = this.eFormDesignerService.getPromptForDataObjects(this.eFormDesignerService.selectedControl);
  }

  cancelClick() {
    this.dialogRef.close();
  }

  saveClick() {
    const mergeTag = '<<' + this.eFormService.formatControlName(this.selectedObject) + '>>';
    this.dialogRef.close(mergeTag);
  }

}
